import dateToString from '@ps-int/ufo-helpers/lib/date/date-to-string';
import type { CloudAPI } from '@yandex-360/telemost-sdk/cloud-api';
import { call, put, select } from 'typed-redux-saga';

import { countMetrika } from '../../../shared/helpers/metrika';
import { cloudApi } from '../../../shared/helpers/transport';
import { RecipientFetchingStatus } from '../features/fetching/types';
import { convertArtifact } from '../features/sidebar/helpers/convert-artifacts';
import { setArtifacts, setLoadingArtifactsStatus } from '../features/sidebar/slice';
import { convertRecipient } from '../helpers/convert-recipient';
import { selectSelectedSessionId, selectSession } from '../selectors';

export function* fetchArtifactsSaga() {
    const selectedSessionId = yield* select(selectSelectedSessionId);
    if (!selectedSessionId) {
        return;
    }
    const selectedSession = yield* select(selectSession(selectedSessionId));
    if (!selectedSession) {
        return;
    }
    yield* put(setLoadingArtifactsStatus('IN_PROGRESS'));
    let response;
    try {
        response = yield* call(
            [cloudApi, cloudApi.getConferencesArtifacts],
            selectedSession.shortUrlId,
            selectedSession.sessionId
        );
        yield* call(
            countMetrika,
            'meeting_history',
            'meeting_stat',
            'show',
            selectedSession.shortUrlId,
            dateToString(new Date(selectedSession.startedAt), 'YYYY-MM-DD')
        );
    } catch (error) {
        yield* put(setLoadingArtifactsStatus('ERROR'));
        return;
    }

    yield* put(
        setArtifacts({
            cloudRecordings: response.cloud_recordings.map(convertArtifact),
            summarizations: response.summarizations.map(convertArtifact),
            localRecordings:
                response.local_recordings.length > 0
                    ? [
                          {
                              recipients: response.local_recordings.map(({ recipient }) =>
                                  convertRecipient(recipient as CloudAPI.ConferenceArtifacts.Recipient)
                              ),
                              recipientFetchingStatus: RecipientFetchingStatus.FETCHED,
                          },
                      ]
                    : [],
        })
    );
    yield* put(setLoadingArtifactsStatus(null));
}
